import { createAction, props } from '@ngrx/store';
import { FetchArgs, PagingTokenFixed } from 'src/app/shared/models/core';
import { ComplianceRequestGridItem } from 'src/app/compliance/compliance-requests/compliance-request-grid-item';
import { Lookup } from 'src/app/shared/models/lookup.model';
import { ComplianceStatusUpdate } from 'src/app/compliance/models/compliance-request';

export const setComplianceRequestsFilter = createAction(
    '[COMPLIANCE REQUESTS COMPONENT] Set Compliance Requests filter',
    props<{ filter: FetchArgs }>()
);

export const setLabTicketRequestsFilter = createAction(
    '[COMPLIANCE REQUESTS COMPONENT] Set Lab Ticket Requests filter',
    props<{ filter: FetchArgs }>()
);

export const setComplianceTicketRequestsFilter = createAction(
    '[COMPLIANCE REQUESTS COMPONENT] Set Compliance Ticket Requests filter',
    props<{ filter: FetchArgs }>()
);

export const getListOfLabTicketRequestsSuccess = createAction(
    '[COMPLIANCE REQUESTS API] Get List Of Lab Tickets Requests Success',
    props<{ complianceRequests: PagingTokenFixed<ComplianceRequestGridItem[]> }>()
);
export const getListOfLabTicketRequestsFailure = createAction(
    '[COMPLIANCE REQUESTS API] Get List Of Lab Tickets Requests Failure',
    props<{ error: unknown }>()
);

export const getListOfComplianceTicketRequestsSuccess = createAction(
    '[COMPLIANCE REQUESTS API] Get List Of Compliance Ticket Requests Success',
    props<{ complianceRequests: PagingTokenFixed<ComplianceRequestGridItem[]> }>()
);
export const getListOfComplianceTicketRequestsFailure = createAction(
    '[COMPLIANCE REQUESTS API] Get List Of Compliance Ticket Requests Failure',
    props<{ error: unknown }>()
);

export const getListOfComplianceRequestsSuccess = createAction(
    '[COMPLIANCE REQUESTS API] Get List Of Compliance Requests Success',
    props<{ complianceRequests: PagingTokenFixed<ComplianceRequestGridItem[]> }>()
);
export const getListOfComplianceRequestsFailure = createAction(
    '[COMPLIANCE REQUESTS API] Get List Of Compliance Requests Failure',
    props<{ error: unknown }>()
);

export const getComplianceRequestsAssignees = createAction(
    '[COMPLIANCE REQUESTS COMPONENT] Get List Of Compliance Requests Assignees'
);

export const getComplianceRequestsAssigneesSuccess = createAction(
    '[COMPLIANCE REQUESTS COMPONENT] Get List Of Compliance Requests Assignees Success',
    props<{ assignees: Lookup[] }>()
);

export const getComplianceRequestsAssigneesFailure = createAction(
    '[COMPLIANCE REQUESTS COMPONENT] Get List Of Compliance Requests Assignees Failure',
    props<{ error: unknown }>()
);

export const getComplianceRequestsAssigneesFilter = createAction(
    '[COMPLIANCE REQUESTS COMPONENT] Get List Of Compliance Requests Assignees Filter'
);

export const getComplianceRequestsAssigneesFilterSuccess = createAction(
    '[COMPLIANCE REQUESTS COMPONENT] Get List Of Compliance Requests Assignees used in the Filter Success',
    props<{ assignees: Lookup[] }>()
);

export const getComplianceRequestsAssigneesFilterFailure = createAction(
    '[COMPLIANCE REQUESTS COMPONENT] Get List Of Compliance Requests Assignees used in the Filter Failure',
    props<{ error: unknown }>()
);

export const bulkStatusUpdate = createAction(
    '[COMPLIANCE REQUESTS COMPONENT] Bulk Status Update',
    props<{ statusUpdate: ComplianceStatusUpdate }>()
);
export const bulkStatusUpdateSuccess = createAction(
    '[COMPLIANCE REQUESTS COMPONENT] Bulk Status Update Success',
    props<{ updatedRequestIds: number[] }>()
);

export const setReloadGridDelay = createAction(
    '[COMPLIANCE REQUESTS COMPONENT] Set Reload Grid with delay',
    props<{ reloadWithDelay: number }>()
);

export const getReloadGridDelay = createAction('[COMPLIANCE REQUESTS COMPONENT] Get Reload Grid with delay');

export const bulkStatusUpdateFailure = createAction('[COMPLIANCE REQUESTS COMPONENT] Bulk Status Update Failure');

export const setUnmappedName = createAction(
    '[COMPLIANCE REQUESTS COMPONENT] Set unmapped name',
    props<{ data: { name: string } }>()
);
